var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMounted)?_c('div',[_c('h6',{staticClass:"mb-2"},[_vm._v("Suppliers that will be updated")]),_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.suppliers_to_update),callback:function ($$v) {_vm.suppliers_to_update=$$v},expression:"suppliers_to_update"}}),_c('div',{attrs:{"id":"suppliersToUpdateTablePaging"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }